import AllergyRadio from "./AllergyRadio";
export default AllergyRadio;